import { render, staticRenderFns } from "./FloorNav.vue?vue&type=template&id=f188c8d0&scoped=true&"
import script from "./FloorNav.vue?vue&type=script&lang=js&"
export * from "./FloorNav.vue?vue&type=script&lang=js&"
import style0 from "./FloorNav.vue?vue&type=style&index=0&id=f188c8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f188c8d0",
  null
  
)

export default component.exports